/**
 * Returns the value of a cookie by name, or null if not found.
 * Cookie values are decoded from application/x-www-form-urlencoded.
 */
export function getCookie(name: string): string | null {
  const nameEq = name + '=';
  const parts = document.cookie.split(';');
  for (const part of parts) {
    const trimmed = part.trim();
    if (trimmed.startsWith(nameEq)) {
      const value = trimmed.slice(nameEq.length);
      try {
        return decodeURIComponent(value);
      } catch {
        return value;
      }
    }
  }
  return null;
}

/**
 * Returns true if a cookie with the given name is present (including empty value).
 * Use this to detect when the CSRF cookie is missing (e.g. after logout or manual deletion).
 */
export function hasCookie(name: string): boolean {
  const nameEq = name + '=';
  const parts = document.cookie.split(';');
  for (const part of parts) {
    if (part.trim().startsWith(nameEq)) {
      return true;
    }
  }
  return false;
}
